import { getMyEmployerActiveLeaseChartData } from "../../../../api/dossier/getMyEmployerActiveLeaseChartData";
import { TERTIARY_GREEN_COLOR } from "../../../../theme";
import { ActiveLeaseChartDatum } from "../../../../types/Chart";
import APChart from "../APChart";

type EmployerAnnualSavingsChartProps = {
  customHeight?: number;
};

const EmployerAnnualSavingsChart = ({
  customHeight,
}: EmployerAnnualSavingsChartProps) => {
  return (
    <APChart
      type="line"
      chartTitle="Annualised Employee Savings"
      getData={() => getMyEmployerActiveLeaseChartData<ActiveLeaseChartDatum>()}
      xAxisOptions={{ type: "time" }}
      yAxisOptions={{ type: "currency" }}
      dimensions={[
        { key: "date", label: "Date" },
        { key: "totalAnnualSavings", label: "Savings" },
      ]}
      isAreaChart={true}
      customColors={[TERTIARY_GREEN_COLOR]}
      customHeight={customHeight}
    />
  );
};

export default EmployerAnnualSavingsChart;
